export const SET_NEW_ORDER_DATA = 'SET_NEW_ORDER_DATA';

export const setEditDataOrder = (data)=> {
    return (dispatch) => {
        console.log('Функция используется',data);

        dispatch({
            type: SET_NEW_ORDER_DATA,
            payload: [...data],
        })

        console.log('Диспатч прошли, должен сработать');
    }
}